import { render, staticRenderFns } from "./Pessoas.vue?vue&type=template&id=37ddfcae&scoped=true&"
import script from "./Pessoas.vue?vue&type=script&lang=js&"
export * from "./Pessoas.vue?vue&type=script&lang=js&"
import style0 from "./Pessoas.vue?vue&type=style&index=0&id=37ddfcae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ddfcae",
  null
  
)

export default component.exports